import { render, staticRenderFns } from "./shopBuy.vue?vue&type=template&id=234edf1c&scoped=true"
import script from "./shopBuy.vue?vue&type=script&lang=js"
export * from "./shopBuy.vue?vue&type=script&lang=js"
import style0 from "./shopBuy.vue?vue&type=style&index=0&id=234edf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234edf1c",
  null
  
)

export default component.exports